import Api from './Api'

export default {
    login(credentials) {
        return Api().post('users/login', credentials);
    },
    getUser(){
        return Api().get('users/profile');
    },
    create(credentials){
        return Api().post('users/signup', credentials);
    },
    update(credentials){
        return Api().put(`users/my-account`, credentials);
    },
    confirmUser(credentials){
        return Api().get(`users/confirmAcount/${credentials}`,);
    },
    auth(){
        return Api().post('users/authenticated');
    },
    updateProfileImage(image){
        const headers = {
            'Content-Type': 'multipart/form-data'
        };
        return Api().post(`users/upload-image`, { image }, { headers });
    }
}